<template>
  <div v-if="qualifyingMenuItems.length > 0" v-click-outside="onClickOutside">
    <div v-for="menuItem in qualifyingMenuItems" :key="menuItem.label">
      <regular-modal
        v-if="menuItem.confirmFirst"
        :ref="`confirmModal${menuItem.label.replaceAll(' ', '')}`"
        :showing="false"
      >
        <template #header>
          <h4 class="text-xl font-headline">
            {{ menuItem.modalTitle || "Confirmation" }}
          </h4>
        </template>
        <template #body>
          <div
            class="w-full max-h-[calc(100vh-200px)] overflow-scroll px-6 py-3"
          >
            <p>{{ getConfirmationMessage(menuItem) }}</p>
          </div>
        </template>
        <template #footer>
          <button
            class="modal-nonprimary-button"
            type="button"
            @click="toggleConfirmModal(menuItem.label.replaceAll(' ', ''))"
          >
            Cancel
          </button>
          <button
            class="modal-primary-button"
            type="button"
            @click="
              toggleConfirmModal(menuItem.label.replaceAll(' ', ''));
              handleApiAction(menuItem.action($event, row, vm));
            "
          >
            <span>
              {{
                menuItem.confirmButtonText ||
                menuItem.confirmButtonLabel ||
                "Yes"
              }}
            </span>
          </button>
        </template>
      </regular-modal>
    </div>
    <a
      ref="btnDropdownRef"
      class="text-xs px-2 py-1 ml-2 text-white"
      :class="{
        'bg-blueDianne rounded-t': dropdownPopoverShow,
        'bg-tiara-300 rounded': !dropdownPopoverShow,
      }"
      href="#"
      @click="toggleDropdown"
    >
      <i class="fas fa-ellipsis-v"></i>
    </a>
    <div
      ref="popoverDropdownRef"
      class="bg-white border border-blueDianne text-base z-50 float-left list-none text-left rounded-b-lg rounded-l-lg min-w-48"
      :class="{
        hidden: !dropdownPopoverShow,
        block: dropdownPopoverShow,
      }"
    >
      <span v-for="menuItem in qualifyingMenuItems" :key="menuItem.label">
        <a
          class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700 cursor-pointer hover:bg-blueDianne hover:text-white rounded"
          @click.prevent="
            toggleDropdown($event);
            doOrConfirm($event, menuItem, row);
          "
        >
          {{ menuItem.label }}
        </a>
      </span>
    </div>
  </div>
</template>
<script>
import { createPopper } from "@popperjs/core";
import vClickOutside from "click-outside-vue3";
import { utils } from "common-frontend";
import RegularModal from "../Modals/Regular.vue";

const { keysToSnake } = utils;

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    RegularModal,
  },
  props: {
    menuItems: Array,
    menuItemFactory: Function,
    row: Object,
    apiBaseUrl: String,
    vm: Object,
  },
  data() {
    return {
      dropdownPopoverShow: false,
      processedMenuItems: [],
      popper: null,
    };
  },
  computed: {
    qualifyingMenuItems() {
      return this.processedMenuItems.filter((menuItem) => {
        return menuItem.qualifier(this.row, this.vm);
      });
    },
  },
  mounted() {
    if (this.menuItemFactory) {
      this.processedMenuItems = this.menuItemFactory(this.row, this.vm);
    } else {
      this.processedMenuItems = this.menuItems;
    }
  },
  beforeUnmount() {
    if (this.popper) {
      this.popper.destroy();
    }
  },
  methods: {
    onClickOutside() {
      if (this.dropdownPopoverShow) {
        this.closeDropdown();
      }
    },
    toggleDropdown(event) {
      event.preventDefault();
      if (this.dropdownPopoverShow) {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    },
    openDropdown() {
      this.dropdownPopoverShow = true;
      this.$nextTick(() => {
        if (this.popper) {
          this.popper.destroy();
        }
        this.popper = createPopper(
          this.$refs.btnDropdownRef,
          this.$refs.popoverDropdownRef,
          {
            placement: "bottom-start",
          },
        );
      });
    },
    closeDropdown() {
      this.dropdownPopoverShow = false;
      if (this.popper) {
        this.popper.destroy();
        this.popper = null;
      }
    },
    doOrConfirm($event, menuItem, row) {
      if (menuItem.confirmFirst) {
        this.toggleConfirmModal(menuItem.label.replaceAll(" ", ""));
      } else {
        this.handleApiAction(menuItem.action($event, row, this.vm));
      }
    },
    toggleConfirmModal(modalName) {
      let ref = this.$refs[`confirmModal${modalName}`];
      if (Array.isArray(ref)) {
        ref = ref[0]; // eslint-disable-line
      }
      ref.toggleModal();
    },
    getConfirmationMessage(menuItem) {
      if (typeof menuItem.confirmationMessage === "function") {
        return menuItem.confirmationMessage(this.row, this.vm);
      }
      return menuItem.confirmationMessage;
    },
    handleApiAction(result) {
      this[result[0]](result[1], result[2], result[3]);
    },
    apiAction(methodAction, url, data) {
      let method = methodAction;
      if (
        methodAction === "postConsole" ||
        methodAction === "postCopy" ||
        methodAction === "postReload"
      ) {
        method = "post";
      } else if (methodAction === "putReload") {
        method = "put";
      } else if (methodAction === "getCopy") {
        method = "get";
      } else if (methodAction === "deleteReload") {
        method = "delete";
      }
      const payload = keysToSnake(data, true);
      this.$api.axios[method](`${this.apiBaseUrl}/${url}`, payload).then(
        (res) => {
          if (methodAction === "postConsole") {
            this.$toast.success("View the console.");
          } else if (
            methodAction === "putReload" ||
            methodAction === "postReload" ||
            methodAction === "deleteReload"
          ) {
            this.$toast.success("This action has been taken.");
            this.$emit("refresh");
          } else if (
            methodAction === "postCopy" ||
            methodAction === "getCopy"
          ) {
            const resultData = [
              new ClipboardItem({
                "text/plain": new Blob([res.data.link], { type: "text/plain" }),
              }),
            ];
            const self = this;
            navigator.clipboard.write(resultData).then(function _() {
              self.$toast.success("Copied to clipboard.");
            });
          } else {
            this.$toast.success("This action has been taken.");
          }
        },
      );
    },
    visitUrl(method, url) {
      window.open(url, "_blank").focus();
    },
    executeFunc(func) {
      func();
    },
  },
};
</script>
